import React, { useEffect, useState, useRef } from 'react';
import { Progress } from 'antd';
import styles from './fetching.module.scss';
import { getIn18Text } from 'api';
const Fetching = props => {
    const [progressNum, setProgressNum] = useState(0);
    const [reqId, setReqId] = useState(0);
    const progressNumRef = useRef(progressNum);
    progressNumRef.current = progressNum;
    const progressAdd = () => {
        if (progressNumRef.current < 90) {
            setProgressNum(progressNumRef.current + 1);
            window.requestAnimationFrame(progressAdd);
        }
        else {
            window.cancelAnimationFrame(reqId);
        }
    };
    const progressStart = () => {
        const rafId = window.requestAnimationFrame(progressAdd);
        setReqId(rafId);
    };
    useEffect(() => {
        progressStart();
    }, []);
    return (React.createElement("div", { className: styles.fetching },
        React.createElement("div", { className: styles.percent },
            progressNum,
            "%"),
        React.createElement(Progress, { className: styles.progress, percent: progressNum, showInfo: false, strokeColor: '#386EE7', strokeWidth: 8, trailColor: 'rgba(38, 42, 51, 0.16)' }),
        React.createElement("p", { className: styles.fetchingIntro }, getIn18Text('JIANCEDAOJIAOCHANG'))));
};
export default Fetching;
